import Tippy from '@tippyjs/react';
import Image from 'next/image';
import type { FC } from 'react';
import { memo, useCallback, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Button } from '../../../../front/src/components/Button/Button';
import { IconClose } from '../../../../front/src/components/icons/Icons';
import iosShareIcon from './ios share icon.png';

export const messages = defineMessages({
  iosInstallPromptMsg: {
    defaultMessage:
      "Installez cette application web sur votre iPhone pour activer les notifications. C'est facile, il suffit de cliquer sur <img></img> puis sur \"Sur l'écran d'accueil\".",
    id: '329rga',
  },
});

// Inspired from https://github.com/rajatsehgal/add-to-home-screen
export const AddToHomeScreenIOS: FC = memo(function AddToHomeScreenIOS(props) {
  const {} = props;

  const [visible, setVisible] = useState(true);
  const hide = useCallback(() => setVisible(false), []);

  return (
    <div className="fixed z-10 bottom-5 left-1/2 -translate-x-1/2 flex w-full justify-center">
      <Tippy
        content={<AddToHomeScreenContent hide={hide} />}
        visible={visible}
        className="tippy-no-padding rounded-lg"
        maxWidth={450}
        // distance={10}
        theme="light-border"
        interactive
      >
        <div className="w-0 h-0"></div>
      </Tippy>
    </div>
  );
});

interface AddToHomeScreenContentProps {
  hide: VoidFunction;
}

const AddToHomeScreenContent: FC<AddToHomeScreenContentProps> = memo(
  function AddToHomeScreenContent(props) {
    const { hide } = props;

    return (
      <div className="flex flex-col">
        <div className="self-end">
          <Button variant="icon" className="no-underline" onClick={hide}>
            <IconClose />
          </Button>
        </div>
        <div className="px-4 pb-4 leading-7">
          <FormattedMessage
            {...messages.iosInstallPromptMsg}
            values={{
              img: (/* chunk: React.ReactNode */) => {
                return (
                  <Image src={iosShareIcon} className="inline w-6 h-6" alt={'Share icon'}></Image>
                );
              },
            }}
          />
        </div>
      </div>
    );
  },
);
